import { GameMutator, GameState, GameStateOptions } from "./game";
import getAllMutators, { Mutator } from "./mutators";


const REDACTED = 'REDACTED' as const;
type  Redacted = typeof REDACTED;
type Dehydrated<T> = T extends (...args: any[]) => any
  ? Redacted
  : T extends object
  ? { [K in keyof T]: Dehydrated<T[K]> }
  : T;

export type DehydratedGameState = Dehydrated<GameState>;
export type DehydratedGameStateOptions = Dehydrated<GameStateOptions>;
export type DehydratedMutator= Dehydrated<Mutator>


export function hydrateMutator(
  dehydrated: DehydratedMutator
): Mutator {
    const allMutators = getAllMutators()
    return allMutators.find(m=>m.name === dehydrated.name)!
}
export function hydrateGame(dehydrated: DehydratedGameState): GameState {
    const gameMutators: GameMutator[] = dehydrated.gameMutators.map(m=>({
        ...m,
        mutator: hydrateMutator(m.mutator)
    }));

    return {
        ...dehydrated,
        gameMutators: gameMutators,
        solutions: dehydrated.solutions.map(s=>({
            mutators: s.mutators.map(m=>hydrateMutator(m))
        })),
        mutationStack: dehydrated.mutationStack.map(m=>hydrateMutator(m))
    };
}
export function dehydrateMutator(mutator: Mutator): DehydratedMutator {
    return {
        ...mutator,
        reverse: REDACTED,
        apply: REDACTED,
        maxReversalLength: REDACTED,
    }
}

export function dehydrateGame(game: GameState): DehydratedGameState {
    return {
        ...game,
        gameMutators: game.gameMutators.map(m=>({
            ...m,
            mutator: dehydrateMutator(m.mutator)
        })),
        solutions: game.solutions.map(s=>({
            mutators: s.mutators.map(m=>dehydrateMutator(m))
        })),
        mutationStack: game.mutationStack.map(m=>dehydrateMutator(m))
    };
}

export function dehydrateGameStateOptions(opts: GameStateOptions): DehydratedGameStateOptions {
    if (opts.onError) {
        throw new Error('Cannot dehydrate GameStateOptions with an onError function');
    }
    return {
        ...opts,
        onError: undefined,
        requiredMutator: opts.requiredMutator && dehydrateMutator(opts.requiredMutator),
        solutionMutators: opts.solutionMutators && opts.solutionMutators.map(m=>dehydrateMutator(m)),
        redHerringMutators: opts.redHerringMutators && opts.redHerringMutators.map(m=>dehydrateMutator(m))
    }
}

export function hydrateGameStateOptions(opts: DehydratedGameStateOptions): GameStateOptions {
    return {
        ...opts,
        onError: undefined,
        requiredMutator: opts.requiredMutator && hydrateMutator(opts.requiredMutator),
        solutionMutators: opts.solutionMutators && opts.solutionMutators.map(m=>hydrateMutator(m)),
        redHerringMutators: opts.redHerringMutators && opts.redHerringMutators.map(m=>hydrateMutator(m))
    }
}
